import Button from 'components/Button';
import Input from 'components/Input';
import { gaTrackSubmit } from 'containers/Configurator/utils';
import React, { Component } from 'react';

class Form extends Component {
    render() {
        const { contextThis, emailIsSending, onSubmit, state, close, isPopup = true } = this.props;
        return (
            <form onSubmit={onSubmit}>
            <input type="text" autoFocus="autofocus" style={{ display: 'none' }} />
            <Input
              label="Your Name"
              contextThis={contextThis}
              name="name"
              placeholder="Please fill out this field"
              required
            />
            <Input
              label="Your Email (for quotation purposes only)"
              contextThis={contextThis}
              name="email"
              type="email"
              isInvalid={state.invalidEmail}
              placeholder="Please fill out this field"
              required
            />
            <Input
              label="Your Phone (optional)"
              contextThis={contextThis}
              name="phone"
              type="phone"
              placeholder="Please fill out this field"
            />
            <Input
              label="Your City & Country"
              contextThis={contextThis}
              name="location"
              placeholder="Please fill out this field"
              required
            />
            <Input
              label="Additional Notes"
              textarea
              contextThis={contextThis}
              name="notes"
              placeholder="Please fill out this field"
            />
            <label ref={el => this.checkInput = el} className="formCheckbox">
              <input
                type="checkbox"
                id="registered"
                style={{ display: 'none' }}
                checked={state.isRegistered}
                onChange={() =>{
                  if(!state.isRegistered && this.contentWrapper){
                    setTimeout(()=>{

                      this.contentWrapper.scrollBy({
                        top: 100,
                        left: 0,
                        behavior: 'smooth'
                      });

                      this.rightPanel.scrollBy({
                        top: 300,
                        left: 0,
                        behavior: 'smooth'
                      });

                    },150);
                  }
                  contextThis.setState({
                    isRegistered: !state.isRegistered,
                  })
                }}
              />
              <label htmlFor="registered" className="check">
                <svg width="18px" height="18px" viewBox="0 0 18 18">
                  <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                  <polyline points="1 9 7 14 15 4" />
                </svg>
              </label>
              <div className="label">
                I am a registered home professional.
                <br />
                <span style={{ fontSize: '10px' }}>
                  (ie. Interior Designer, Home Theatre Installer, Home Builder, Design Firm)
                </span>
              </div>
            </label>
            <input
              type="submit"
              hidden
              ref={(ref) => {
                this.submit = ref
              }}
            />

            {state.isRegistered && (
              <div className={`additional`}>
                <div className="horizontalSplit" />
                <Input
                  label="Company Name"
                  contextThis={contextThis}
                  placeholder="Please fill out this field"
                  required={state.isRegistered}
                  name="companyName"
                />
                <Input
                  label="Company Email"
                  contextThis={contextThis}
                  placeholder="Please fill out this field"
                  required={state.isRegistered}
                  name="companyEmail"
                />
                <Input
                  label="Company Website"
                  contextThis={contextThis}
                  placeholder="Please fill out this field"
                  required={state.isRegistered}
                  name="companyWebsite"
                />
                <Input
                  label="Company Phone"
                  contextThis={contextThis}
                  placeholder="Please fill out this field"
                  required={state.isRegistered}
                  name="companyPhone"
                />
                <div className="question">Which of the following best describes your company?</div>
                <div className="checkbox-columns">
                  
                {[
                  'AV Dealer/Installer',
                  'Design Firm',
                  'Home Builder',
                  'Interior Design',
                  'Architect',
                  'Other',
                ].map((p, i) => (
                  <label key={i} className="formCheckbox thin">
                    <input
                      type="checkbox"
                      id={'formCheckbox' + i}
                      style={{ display: 'none' }}
                      checked={state.form.companyTypes[p]}
                      onChange={() => {
                        const form = state.form
                        form.companyTypes = {
                          ...form.companyTypes,
                          [p]: !state.form.companyTypes[p],
                        }
                        contextThis.setState({
                          form,
                        })
                      }}
                    />
                    <label for={'formCheckbox' + i} className="check">
                      <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                        <polyline points="1 9 7 14 15 4" />
                      </svg>
                    </label>
                    <div className="label">{p}</div>
                  </label>
                ))}
                </div>

                <div className="question">In addition to a price quote, do you require any of the following?</div>
                <div className="checkbox-columns">
                  
                  {['Material Samples', '3D Layout Drawings'].map((p, i) => (
                    <label className="formCheckbox thin">
                      <input
                        type="checkbox"
                        id={'formCheckbox0' + i}
                        style={{ display: 'none' }}
                        checked={state.form.additionalRequirements[p]}
                        onChange={() => {
                          const form = state.form
                          form.additionalRequirements = {
                            ...form.additionalRequirements,
                            [p]: !state.form.additionalRequirements[p],
                          }
                          contextThis.setState({
                            form,
                          })
                        }}
                      />
                      <label for={'formCheckbox0' + i} className="check">
                        <svg width="18px" height="18px" viewBox="0 0 18 18">
                          <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                          <polyline points="1 9 7 14 15 4" />
                        </svg>
                      </label>
                      <div className="label">{p}</div>
                    </label>
                  ))}
                </div>
              </div>
            )}
           
            <Button
              className="button submitButton onlyDesktop"
              wide
              isLoading={emailIsSending}
              onClick={(e) => {
                e.preventDefault()

                if (this.submit) {
                  this.submit.click()
                  gaTrackSubmit()
                }
              }}
            >
              <a>Submit for Price Quote</a>
            </Button>

            {isPopup && (
                
            <Button style={{marginTop: 10}}
                className="button block"
                wide
                
                onClick={(e) => {
                    e.preventDefault()

                    close();
                }}
                >
                <i className="arrow left" />
                <a>BACK</a>
            </Button>
            )}
              
          </form>
        );
    }
}

export default Form;